import * as tslib_1 from "tslib";
import { onOptOutToggle, renderOptOut } from './ClientOptOutItem';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { CommandBarButton } from 'office-ui-fabric-react/lib/Button';
import { isBulkActionRunning } from 'owa-bulk-action-store';
import { FilterableCommandBar } from 'owa-filterable-menu';
import { FilterableMenuItem } from 'owa-filterable-menu';
import { getGroupId } from 'owa-group-utils';
import { showInImmersiveReader } from 'owa-immersive-reader-store';
import { selectNextRow, selectPreviousRow } from 'owa-mail-actions';
import { getCategoryMenuPropertiesForCommandBar } from 'owa-mail-category-view';
import { getMailMenuItemShouldShowMap } from 'owa-mail-filterable-menu-behavior';
import getMailMenuItemShouldDisable from 'owa-mail-filterable-menu-behavior/lib/actions/getMailMenuItemShouldDisable';
import { resetFocus } from 'owa-mail-focus-manager';
import createScheduleSubMenu from 'owa-mail-list-context-menu/lib/helpers/createScheduleSubMenu';
import isItemPartCommandBarOperation from 'owa-mail-list-store/lib/selectors/isItemPartCommandBarOperation';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import * as markReadActions from 'owa-mail-mark-read-actions';
import { lazyMarkItemsAsReadBasedOnNodeIds } from 'owa-mail-mark-read-actions';
import checkAndCreateNewMessage from 'owa-mail-message-actions/lib/actions/checkAndCreateNewMessage';
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import { getMoveToPropertiesForCommandBar } from 'owa-mail-movetofolder-view';
import isReadingPaneBottom from 'owa-mail-reading-pane-store/lib/utils/isReadingPaneBottom';
import isReplyAllTheDefaultResponse from 'owa-mail-reading-pane-store/lib/utils/isReplyAllTheDefaultResponse';
import { lazyShowInboxRuleDialog } from 'owa-mail-rule-view';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import { lazyShowSweepDialog } from 'owa-mail-sweep-view';
import * as lazyTriageActions from 'owa-mail-triage-action';
import * as undoActions from 'owa-mail-undo';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import { listViewStore, MailRowDataPropertyGetter, } from 'owa-mail-list-store';
import { lazyForwardConversation, lazyReplyToConversation, lazyForwardItem, lazyReplyToItem, lazyPrintConversation, lazyPrintItem, lazyShowConversationInImmersiveReader, } from 'owa-mail-message-actions';
var styles = require('./MailCommandingBar.scss');
var MailCommandingBarComputedState = /** @class */ (function () {
    function MailCommandingBarComputedState(tableViewId) {
        this.tableViewId = tableViewId;
    }
    Object.defineProperty(MailCommandingBarComputedState.prototype, "tableView", {
        get: function () {
            return listViewStore.tableViews.get(this.tableViewId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBarComputedState.prototype, "isItemPartCommandBarOperation", {
        get: function () {
            return isItemPartCommandBarOperation(this.tableViewId);
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        computed
    ], MailCommandingBarComputedState.prototype, "tableView", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBarComputedState.prototype, "isItemPartCommandBarOperation", null);
    return MailCommandingBarComputedState;
}());
var MailCommandingBar = /** @class */ (function (_super) {
    tslib_1.__extends(MailCommandingBar, _super);
    function MailCommandingBar(props) {
        var _this = _super.call(this, props) || this;
        _this.onReplyAllRow = function (isReplyAll) {
            var tableView = _this.computedState.tableView;
            var rowKey = tslib_1.__spread(tableView.selectedRowKeys.keys())[0];
            var rowId = MailRowDataPropertyGetter.getRowClientItemId(rowKey, tableView);
            var instrumentationContexts;
            if (tableView.tableQuery.type == 1 /* Search */) {
                instrumentationContexts = getInstrumentationContextsFromTableView([rowKey], tableView);
            }
            switch (tableView.tableQuery.listViewType) {
                case 0 /* Conversation */:
                    lazyReplyToConversation.importAndExecute(rowId, isReplyAll, 'CommandBar', instrumentationContexts, isReadingPaneBottom() /*isFullCompose*/);
                    break;
                case 1 /* Message */:
                    lazyReplyToItem.importAndExecute(rowId, isReplyAll, instrumentationContexts, 'CommandBar');
            }
        };
        _this.onForwardRow = function () {
            var tableView = _this.computedState.tableView;
            var rowKey = tslib_1.__spread(tableView.selectedRowKeys.keys())[0];
            var rowId = MailRowDataPropertyGetter.getRowClientItemId(rowKey, tableView);
            var instrumentationContexts;
            if (tableView.tableQuery.type == 1 /* Search */) {
                instrumentationContexts = getInstrumentationContextsFromTableView([rowKey], tableView);
            }
            switch (tableView.tableQuery.listViewType) {
                case 0 /* Conversation */:
                    lazyForwardConversation.importAndExecute(rowId, 'CommandBar', instrumentationContexts);
                    break;
                case 1 /* Message */:
                    lazyForwardItem.importAndExecute(rowId, 'CommandBar', instrumentationContexts);
                    break;
            }
        };
        _this.onDeleteClicked = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var tableView, deleteItemsBasedOnNodeIds;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tableView = this.computedState.tableView;
                        if (!tableView.isInVirtualSelectAllMode) return [3 /*break*/, 1];
                        // When in virtual selection, i.e non search and select all mode,
                        // delete all in the folder
                        lazyTriageActions.lazyEmptyTableView.importAndExecute(tableView, false /*isExplicitSoftDelete*/, 'CommandBar', tableView.virutalSelectAllExclusionList);
                        return [3 /*break*/, 4];
                    case 1:
                        if (!this.computedState.isItemPartCommandBarOperation) return [3 /*break*/, 3];
                        return [4 /*yield*/, lazyTriageActions.lazyDeleteItemsBasedOnNodeIds.import()];
                    case 2:
                        deleteItemsBasedOnNodeIds = _a.sent();
                        deleteItemsBasedOnNodeIds(listViewStore.expandedConversationViewState.selectedNodeIds, tableView.id, 'CommandBar');
                        return [3 /*break*/, 4];
                    case 3:
                        lazyTriageActions.lazyDeleteMailListRows.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView.id, false /*isExplicitSoftDelete*/, 'CommandBar');
                        _a.label = 4;
                    case 4:
                        resetFocus();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onArchiveClicked = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var tableView, moveItemsBasedOnNodeIds;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tableView = this.computedState.tableView;
                        if (!this.computedState.isItemPartCommandBarOperation) return [3 /*break*/, 2];
                        return [4 /*yield*/, lazyTriageActions.lazyMoveItemsBasedOnNodeIds.import()];
                    case 1:
                        moveItemsBasedOnNodeIds = _a.sent();
                        moveItemsBasedOnNodeIds(listViewStore.expandedConversationViewState.selectedNodeIds, folderNameToId('archive'), tableView.id, 'CommandBar');
                        return [3 /*break*/, 3];
                    case 2:
                        lazyTriageActions.lazyArchiveMailListRows.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView, 'CommandBar');
                        _a.label = 3;
                    case 3:
                        resetFocus();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onRestoreClicked = function () {
            var tableView = _this.computedState.tableView;
            lazyTriageActions.lazyRestoreMailListRowsAction.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), _this.computedState.tableView.id);
            resetFocus();
        };
        _this.onJunkNotJunkClicked = function (isJunkValueToSet) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var tableView, lazyMarkItemsJunkNotJunkBasedOnNodeIds;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tableView = this.computedState.tableView;
                        if (!this.computedState.isItemPartCommandBarOperation) return [3 /*break*/, 2];
                        return [4 /*yield*/, lazyTriageActions.lazyMarkItemsJunkNotJunkBasedOnNodeIds.import()];
                    case 1:
                        lazyMarkItemsJunkNotJunkBasedOnNodeIds = _a.sent();
                        lazyMarkItemsJunkNotJunkBasedOnNodeIds(listViewStore.expandedConversationViewState.selectedNodeIds, tableView.id, isJunkValueToSet, 'CommandBar');
                        return [3 /*break*/, 3];
                    case 2:
                        lazyTriageActions.lazyMarkRowsJunkNotJunk.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView, isJunkValueToSet, 'CommandBar' /* actionSource */);
                        _a.label = 3;
                    case 3:
                        resetFocus();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onPhishingClicked = function () {
            var tableView = _this.computedState.tableView;
            lazyTriageActions.lazyMarkRowsAsPhishingFromTable.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView, 'CommandBar');
            resetFocus();
        };
        _this.onDeleteAllClicked = function () {
            var tableView = _this.computedState.tableView;
            if (tableView.tableQuery.type == 1 /* Search */) {
                // currently we do not support EmptyFolder in search view
                lazyTriageActions.lazyEmptySearchTableView.importAndExecute(tableView);
            }
            else {
                lazyTriageActions.lazyEmptyTableView.importAndExecute(tableView, false /*isExplicitSoftDelete*/, 'CommandBar', [] /*rowKeysToExclude*/);
            }
        };
        _this.onMarkAsReadClicked = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var tableView, isInVirtualSelectAllMode, rowKeysToActOn, exclusionList, markItemsAsReadBasedOnNodeIds;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tableView = this.computedState.tableView;
                        isInVirtualSelectAllMode = tableView.isInVirtualSelectAllMode;
                        rowKeysToActOn = isInVirtualSelectAllMode
                            ? []
                            : tslib_1.__spread(tableView.selectedRowKeys.keys());
                        exclusionList = isInVirtualSelectAllMode
                            ? tableView.virutalSelectAllExclusionList
                            : [];
                        if (!this.computedState.isItemPartCommandBarOperation) return [3 /*break*/, 2];
                        return [4 /*yield*/, lazyMarkItemsAsReadBasedOnNodeIds.import()];
                    case 1:
                        markItemsAsReadBasedOnNodeIds = _a.sent();
                        markItemsAsReadBasedOnNodeIds(listViewStore.expandedConversationViewState.selectedNodeIds, tableView.id, true /* isReadValueToSet */, true /* isExplicit */, 'CommandBar');
                        return [3 /*break*/, 3];
                    case 2:
                        markReadActions.lazyMarkAsReadInTable.importAndExecute('CommandBar', exclusionList, isInVirtualSelectAllMode /* isActingOnAllItemsInTable */, true /* isReadValueToSet */, rowKeysToActOn, tableView);
                        _a.label = 3;
                    case 3:
                        resetFocus();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onMarkAsUnreadClicked = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var tableView, isInVirtualSelectAllMode, rowKeysToActOn, exclusionList, markItemsAsReadBasedOnNodeIds;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tableView = this.computedState.tableView;
                        isInVirtualSelectAllMode = tableView.isInVirtualSelectAllMode;
                        rowKeysToActOn = isInVirtualSelectAllMode
                            ? []
                            : tslib_1.__spread(tableView.selectedRowKeys.keys());
                        exclusionList = isInVirtualSelectAllMode
                            ? tableView.virutalSelectAllExclusionList
                            : [];
                        if (!this.computedState.isItemPartCommandBarOperation) return [3 /*break*/, 2];
                        return [4 /*yield*/, lazyMarkItemsAsReadBasedOnNodeIds.import()];
                    case 1:
                        markItemsAsReadBasedOnNodeIds = _a.sent();
                        markItemsAsReadBasedOnNodeIds(listViewStore.expandedConversationViewState.selectedNodeIds, tableView.id, false /* isReadValueToSet */, true /* isExplicit */, 'CommandBar');
                        return [3 /*break*/, 3];
                    case 2:
                        markReadActions.lazyMarkAsReadInTable.importAndExecute('CommandBar', exclusionList, isInVirtualSelectAllMode /* isActingOnAllItemsInTable */, false /* isReadValueToSet */, rowKeysToActOn, tableView);
                        _a.label = 3;
                    case 3:
                        resetFocus();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onBlockClicked = function () {
            var tableView = _this.computedState.tableView;
            lazyTriageActions.lazyBlockLastSendersFromTable.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView, 'CommandBar');
            resetFocus();
        };
        _this.onSweepClicked = function () {
            var tableView = _this.computedState.tableView;
            lazyShowSweepDialog.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView);
            resetFocus();
        };
        _this.onFlagClicked = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var tableView, setItemsFlagStateBasedOnNodeIds;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tableView = this.computedState.tableView;
                        if (!this.computedState.isItemPartCommandBarOperation) return [3 /*break*/, 2];
                        return [4 /*yield*/, lazyTriageActions.lazySetItemsFlagStateBasedOnNodeIds.import()];
                    case 1:
                        setItemsFlagStateBasedOnNodeIds = _a.sent();
                        setItemsFlagStateBasedOnNodeIds(listViewStore.expandedConversationViewState.selectedNodeIds, tableView.id, 'Flagged', 'CommandBar');
                        return [3 /*break*/, 3];
                    case 2:
                        lazyTriageActions.lazySetMailListRowsFlagState.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView.id, 'Flagged', 'CommandBar');
                        _a.label = 3;
                    case 3:
                        resetFocus();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onUnFlagClicked = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var tableView, setItemsFlagStateBasedOnNodeIds;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tableView = this.computedState.tableView;
                        if (!this.computedState.isItemPartCommandBarOperation) return [3 /*break*/, 2];
                        return [4 /*yield*/, lazyTriageActions.lazySetItemsFlagStateBasedOnNodeIds.import()];
                    case 1:
                        setItemsFlagStateBasedOnNodeIds = _a.sent();
                        setItemsFlagStateBasedOnNodeIds(listViewStore.expandedConversationViewState.selectedNodeIds, tableView.id, 'NotFlagged', 'CommandBar');
                        return [3 /*break*/, 3];
                    case 2:
                        lazyTriageActions.lazySetMailListRowsFlagState.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), this.computedState.tableView.id, 'NotFlagged', 'CommandBar');
                        _a.label = 3;
                    case 3:
                        resetFocus();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onPinClicked = function () {
            var tableView = _this.computedState.tableView;
            lazyTriageActions.lazyMarkRowsPinnedUnpinned.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView.id, true /* shouldMarkAsPinned */, 'CommandBar');
            resetFocus();
        };
        _this.onUnpinClicked = function () {
            var tableView = _this.computedState.tableView;
            lazyTriageActions.lazyMarkRowsPinnedUnpinned.importAndExecute(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView.id, false /* shouldMarkAsPinned */, 'CommandBar');
            resetFocus();
        };
        _this.onIgnoreClicked = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var tableView, toggleIgnoreConversations;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tableView = this.computedState.tableView;
                        return [4 /*yield*/, lazyTriageActions.lazyToggleIgnoreConversations.import()];
                    case 1:
                        toggleIgnoreConversations = _a.sent();
                        toggleIgnoreConversations(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView.id, true /*shouldIgnore*/, 'CommandBar');
                        resetFocus();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onStopIgnoringClicked = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var tableView, toggleIgnoreConversations;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tableView = this.computedState.tableView;
                        return [4 /*yield*/, lazyTriageActions.lazyToggleIgnoreConversations.import()];
                    case 1:
                        toggleIgnoreConversations = _a.sent();
                        toggleIgnoreConversations(tslib_1.__spread(tableView.selectedRowKeys.keys()), tableView.id, false /*shouldIgnore*/, 'CommandBar');
                        resetFocus();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onShowInImmersiveReaderClicked = function () {
            var rowKey = tslib_1.__spread(_this.computedState.tableView.selectedRowKeys.keys())[0];
            var selectedRowId = MailRowDataPropertyGetter.getRowClientItemId(rowKey, _this.computedState.tableView);
            switch (_this.computedState.tableView.tableQuery.listViewType) {
                case 0 /* Conversation */:
                    lazyShowConversationInImmersiveReader.importAndExecute(selectedRowId /* conversationId */, 'CommandBar');
                    break;
                case 1 /* Message */:
                    showInImmersiveReader(selectedRowId /* itemId */, 'CommandBar');
                    break;
            }
        };
        _this.onUndoClicked = function () {
            undoActions.lazyUndo.importAndExecute('CommandBar');
            resetFocus();
        };
        _this.onUpClicked = function () {
            var tableView = _this.computedState.tableView;
            var selectedRowkeys = tableView.selectedRowKeys.keys();
            if (!selectedRowkeys[0]) {
                throw new Error('undefined row key ' + selectedRowkeys);
            }
            markReadActions.lazyOnNavigateAwayViaUpDown.importAndExecute(selectedRowkeys[0], tableView);
            selectPreviousRow(tableView, MailListItemSelectionSource.CommandBarArrows);
        };
        _this.onDownClicked = function () {
            var tableView = _this.computedState.tableView;
            var selectedRowkeys = tableView.selectedRowKeys.keys();
            if (!selectedRowkeys[0]) {
                throw new Error('undefined row key ' + selectedRowkeys);
            }
            markReadActions.lazyOnNavigateAwayViaUpDown.importAndExecute(selectedRowkeys[0], tableView);
            selectNextRow(tableView, MailListItemSelectionSource.CommandBarArrows);
        };
        _this.onMarkAllAsReadClicked = function () {
            var tableView = _this.computedState.tableView;
            var isInVirtualSelectAllMode;
            var exclusionList;
            var rowKeysToActOn;
            /**
             * "Mark all as read" commands can generally be treated as virtual
             * select all. However, in the case of seach results, it needs to be
             * special-cased to use all item IDs since there's no backing folder
             * for the markAllAsReadService to use.
             */
            if (tableView.tableQuery.type === 1 /* Search */) {
                isInVirtualSelectAllMode = false;
                exclusionList = [];
                rowKeysToActOn = tableView.rowKeys;
            }
            else {
                isInVirtualSelectAllMode = true;
                exclusionList = tableView.virutalSelectAllExclusionList;
                rowKeysToActOn = [];
            }
            markReadActions.lazyMarkAsReadInTable.importAndExecute('CommandBar', exclusionList, isInVirtualSelectAllMode /* isActingOnAllItemsInTable */, true /* isReadValueToSet */, rowKeysToActOn, tableView);
            resetFocus();
        };
        /**
         * Called when user clicks on the create rule menu item
         */
        _this.onCreateRuleClicked = function () {
            // Get the sender from the single selected conversation.
            // Ensuring a single selection and that the selection
            // has an SMTP address is handled in the context menu should show behavior map
            var tableView = _this.computedState.tableView;
            var selectedRowKeys = tableView.selectedRowKeys.keys();
            var sender = MailRowDataPropertyGetter.getLastSenderMailbox(selectedRowKeys[0], tableView);
            lazyShowInboxRuleDialog.importAndExecute(sender, 'CommandBar');
        };
        _this.onPrintClicked = function () {
            var rowKey = tslib_1.__spread(_this.computedState.tableView.selectedRowKeys.keys())[0];
            var selectedRowId = MailRowDataPropertyGetter.getRowClientItemId(rowKey, _this.computedState.tableView);
            switch (_this.computedState.tableView.tableQuery.listViewType) {
                case 0 /* Conversation */:
                    lazyPrintConversation.importAndExecute(selectedRowId /* conversationId */, 'CommandBar');
                    break;
                case 1 /* Message */:
                    lazyPrintItem.importAndExecute(selectedRowId /* itemId */, 'CommandBar');
                    break;
            }
            resetFocus();
        };
        _this.onTranslateClicked = function () {
            lazyTriageActions.lazyTranslateFromTable.importAndExecute(tslib_1.__spread(_this.computedState.tableView.selectedRowKeys.keys()), _this.computedState.tableView, 'CommandBar');
            resetFocus();
        };
        _this.initializeComputedState(props);
        _this.shouldShowBehaviorMap = getMailMenuItemShouldShowMap();
        return _this;
    }
    MailCommandingBar.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.tableViewId != nextProps.tableViewId) {
            this.initializeComputedState(nextProps);
        }
    };
    MailCommandingBar.prototype.initializeComputedState = function (props) {
        this.computedState = new MailCommandingBarComputedState(props.tableViewId);
    };
    MailCommandingBar.prototype.render = function () {
        return (React.createElement(FilterableCommandBar, { filterableItems: this.commandingBarItems, elipisisAriaLabel: strings.mailEllipsisAriaLabelText }));
    };
    Object.defineProperty(MailCommandingBar.prototype, "commandingBarItems", {
        get: function () {
            // Items to display in the Display Bar.
            return [
                this.newMenuItem,
                this.replyMenuItem,
                this.deleteMenuItem,
                this.restoreMenuItem,
                this.archiveDraftMenuItem,
                this.junkMenuItem,
                this.notJunkMenuItem,
                this.sweepMenuItem,
                this.moveToMenuItem,
                this.categoryMenuItem,
                this.emptyFolderMenuItem,
                this.markAllAsReadMenuItem,
                this.markAsUnreadMenuItem,
                this.markAsReadMenuItem,
                this.scheduleMenuItem,
                this.flagMenuItem,
                this.unflagMenuItem,
                this.pinMenuItem,
                this.unpinMenuItem,
                this.ignoreMenuItem,
                this.stopIgnoringMenuItem,
                this.overflowDivider,
                this.createRuleMenuItem,
                this.printMenuItem,
                this.translateMenuItem,
                this.showInImmersiveReaderMenuItem,
                this.undoMenuItem,
                this.optOutMenuItem,
                // Items to display on the right in immersive view.
                this.selectPreviousMenuItem,
                this.selectNextMenuItem,
                this.closeImmersiveReadingPaneMenuItem,
            ];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "newMenuItem", {
        get: function () {
            var _this = this;
            return new FilterableMenuItem(strings.newMailAction, "Add" /* Add */, function () {
                var tableView = _this.computedState.tableView;
                var groupId = getGroupId(tableView);
                checkAndCreateNewMessage('CommandBar', groupId);
            }, this.shouldShowBehaviorMap[19 /* NewMessage */], null, getMailMenuItemShouldDisable(19 /* NewMessage */) /* disabled */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "groupId", {
        get: function () {
            var tableView = listViewStore.tableViews.get(this.props.tableViewId);
            return getGroupId(tableView);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "categoryMenuItem", {
        get: function () {
            var tableView = listViewStore.tableViews.get(this.props.tableViewId);
            return new FilterableMenuItem(strings.categoryMenuItemMenuText, "Tag" /* Tag */, function () { }, this.shouldShowBehaviorMap[4 /* Categories */], 0 /* Left */, false, // disabled
            getCategoryMenuPropertiesForCommandBar(tableView, 'CommandBar'));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "replyMenuItem", {
        get: function () {
            var _this = this;
            var isReplyAll = isReplyAllTheDefaultResponse();
            return new FilterableMenuItem('', isReplyAll ? "ReplyAll" /* ReplyAll */ : "Reply" /* Reply */, function () { }, isReplyAll
                ? this.shouldShowBehaviorMap[26 /* ReplyReplyAllForwardCommandBar */]
                : this.shouldShowBehaviorMap[24 /* Reply */], null /* display option */, false /* disable */, [], isReplyAll ? 'replyAllMain' : 'replyMain' /* key */, function () {
                return (React.createElement(CommandBarButton, { iconProps: isReplyAll ? { iconName: 'ReplyAll' } : { iconName: 'Reply' }, "data-automation-id": isReplyAll ? 'replyAll' : 'reply', disabled: false, text: isReplyAll ? strings.itemHeaderReplyAll : strings.itemHeaderReply, onClick: function () { return _this.onReplyAllRow(isReplyAll /* isReplyAll */); }, split: true, styles: {
                        splitButtonMenuIcon: styles.replyButtonContent,
                        splitButtonContainer: styles.replyButtonContainer,
                        splitButtonMenuButton: styles.replyButtonContainerHovered,
                        root: styles.replyButtonContainerHovered,
                        label: styles.replyButtonContent,
                        icon: styles.replyButtonContent,
                    }, menuProps: {
                        items: [
                            {
                                key: 'reply',
                                name: strings.itemHeaderReply,
                                onClick: function () { return _this.onReplyAllRow(false /* isReplyAll */); },
                            },
                            {
                                key: 'replyall',
                                name: strings.itemHeaderReplyAll,
                                onClick: function () { return _this.onReplyAllRow(true /* isReplyAll */); },
                            },
                            {
                                key: 'forward',
                                name: strings.itemHeaderForward,
                                onClick: _this.onForwardRow,
                            },
                        ],
                    } }));
            } /* onRender */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "deleteMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.deleteItem, "Delete" /* Delete */, this.onDeleteClicked, this.shouldShowBehaviorMap[6 /* Delete */], null /* display option */, getMailMenuItemShouldDisable(6 /* Delete */));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "restoreMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.restoreItem, "RevToggleKey" /* RevToggleKey */, this.onRestoreClicked, this.shouldShowBehaviorMap[27 /* Restore */]);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "archiveDraftMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.archive, "Archive" /* Archive */, this.onArchiveClicked, this.shouldShowBehaviorMap[2 /* Archive */]);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "junkMenuItem", {
        get: function () {
            var _this = this;
            return new FilterableMenuItem(strings.junk, "Blocked" /* Blocked */, function () { } /* onClick */, this.shouldShowBehaviorMap[12 /* MarkAsJunk */], 0 /* Left */, false /* disabled */, [
                new FilterableMenuItem(strings.junk, null /* icon */, function () {
                    return _this.onJunkNotJunkClicked(true /* isJunkValueToSet */);
                }),
                new FilterableMenuItem(strings.phishing, null /* icon */, this.onPhishingClicked),
                new FilterableMenuItem(strings.block, null /* icon */, this.onBlockClicked, this.shouldShowBehaviorMap[3 /* Block */]),
            ]);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "notJunkMenuItem", {
        get: function () {
            var _this = this;
            return new FilterableMenuItem(strings.notjunk, null /* icon */, function () { } /* onClick */, this.shouldShowBehaviorMap[13 /* MarkAsNotJunk */], 0 /* Left */, false /* disabled*/, [
                new FilterableMenuItem(strings.notjunk, null /* icon */, function () {
                    return _this.onJunkNotJunkClicked(false /* isJunkValueToSet */);
                }),
                new FilterableMenuItem(strings.phishing, null /* icon */, this.onPhishingClicked),
                new FilterableMenuItem(strings.block, null /* icon */, this.onBlockClicked, this.shouldShowBehaviorMap[3 /* Block */]),
            ]);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "translateMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.itemHeaderTranslate, null /* icon */, this.onTranslateClicked, this.shouldShowBehaviorMap[29 /* Translate */], 2 /* Overflow */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "sweepMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.sweep, "Broom" /* Broom */, this.onSweepClicked, this.shouldShowBehaviorMap[34 /* Sweep */]);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "moveToMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.moveTo, "FabricMovetoFolder" /* FabricMovetoFolder */, function () { }, this.shouldShowBehaviorMap[16 /* Move */], 0 /* Left */, false, // disabled
            getMoveToPropertiesForCommandBar(listViewStore.tableViews.get(this.props.tableViewId), 'CommandBar', this.shouldShowBehaviorMap));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "emptyFolderMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.emptyFolder, "Delete" /* Delete */, this.onDeleteAllClicked, this.shouldShowBehaviorMap[7 /* EmptyFolder */], 0 /* Left */, isBulkActionRunning(listViewStore.tableViews.get(this.props.tableViewId).serverFolderId));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "markAllAsReadMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.markAllAsRead, "Read" /* Read */, this.onMarkAllAsReadClicked, this.shouldShowBehaviorMap[11 /* MarkAllAsRead */], 0 /* Left */, isBulkActionRunning(listViewStore.tableViews.get(this.props.tableViewId).serverFolderId));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "markAsUnreadMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.markAsUnread, this.groupId ? "Read" /* Read */ : null /* icon */, this.onMarkAsUnreadClicked, this.shouldShowBehaviorMap[15 /* MarkAsUnread */], this.groupId ? 0 /* Left */ : 2 /* Overflow */, isBulkActionRunning(listViewStore.tableViews.get(this.props.tableViewId).serverFolderId));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "markAsReadMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.markAsRead, this.groupId ? "Read" /* Read */ : null /* icon */, this.onMarkAsReadClicked, this.shouldShowBehaviorMap[14 /* MarkAsRead */], this.groupId ? 0 /* Left */ : 2 /* Overflow */, isBulkActionRunning(listViewStore.tableViews.get(this.props.tableViewId).serverFolderId));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "scheduleMenuItem", {
        get: function () {
            var tableView = this.computedState.tableView;
            var selectedRowKeys = tslib_1.__spread(tableView.selectedRowKeys.keys());
            return new FilterableMenuItem(strings.schedule, "Clock" /* Clock */, function () { }, this.shouldShowBehaviorMap[30 /* Schedule */], null /* displayOption*/, false /* disabled */, createScheduleSubMenu(selectedRowKeys, this.props.tableViewId, 'CommandBar' /* actionSource */));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "flagMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.flag, null, // no icon
            this.onFlagClicked, this.shouldShowBehaviorMap[8 /* Flag */], 2 /* Overflow */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "unflagMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.unflag, null /* icon */, this.onUnFlagClicked, this.shouldShowBehaviorMap[36 /* Unflag */], 2 /* Overflow */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "pinMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.pin, null /* icon */, this.onPinClicked, this.shouldShowBehaviorMap[22 /* Pin */], 2 /* Overflow */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "unpinMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.unpin, null /* icon */, this.onUnpinClicked, this.shouldShowBehaviorMap[37 /* Unpin */], 2 /* Overflow */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "ignoreMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.ignore, null /* icon */, this.onIgnoreClicked, this.shouldShowBehaviorMap[9 /* Ignore */], 2 /* Overflow */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "stopIgnoringMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.stopIgnoring, null /* icon */, this.onStopIgnoringClicked, this.shouldShowBehaviorMap[33 /* StopIgnoring */], 2 /* Overflow */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "overflowDivider", {
        get: function () {
            return new FilterableMenuItem('-', '-', null, this.shouldShowBehaviorMap[21 /* OverflowDivider */], 2 /* Overflow */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "createRuleMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.createRule, null /* icon */, this.onCreateRuleClicked, this.shouldShowBehaviorMap[10 /* InboxRule */], 2 /* Overflow */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "printMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.print, null /* icon */, this.onPrintClicked, this.shouldShowBehaviorMap[23 /* Print */], 2 /* Overflow */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "showInImmersiveReaderMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.showInImmersiveReader, null /* icon */, this.onShowInImmersiveReaderClicked, this.shouldShowBehaviorMap[31 /* ShowInImmersiveReader */], 2 /* Overflow */);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "undoMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.undoCommandingBar /* name */, "Undo" /* Undo */, this.onUndoClicked, this.shouldShowBehaviorMap[35 /* Undo */] /* Hide in search mode and immersive RP */, 0 /* Left */, !undoActions.hasUndoableAction());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "optOutMenuItem", {
        get: function () {
            return new FilterableMenuItem(strings.optOutToggleLabel, null, onOptOutToggle, this.shouldShowBehaviorMap[5 /* ClientOptOut */], 1 /* Right */, false, null, null, renderOptOut);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "selectPreviousMenuItem", {
        get: function () {
            var tableView = this.computedState.tableView;
            var selectedRowKeys = tableView.selectedRowKeys.keys();
            return new FilterableMenuItem(null /* name */, "Up" /* Up */, this.onUpClicked, this.shouldShowBehaviorMap[28 /* SelectionNavigation */], 1 /* Right */, tableView.selectedRowKeys.size == 1 && tableView.rowKeys[0] == selectedRowKeys[0]); // disabled for the first item of the table
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "selectNextMenuItem", {
        get: function () {
            var tableView = this.computedState.tableView;
            var selectedRowKeys = tableView.selectedRowKeys.keys();
            return new FilterableMenuItem(null /* name */, "Down" /* Down */, this.onDownClicked, this.shouldShowBehaviorMap[28 /* SelectionNavigation */], 1 /* Right */, tableView.selectedRowKeys.size == 1 &&
                tableView.rowKeys[tableView.rowKeys.length - 1] == selectedRowKeys[0]); // disabled for the last item of the table
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailCommandingBar.prototype, "closeImmersiveReadingPaneMenuItem", {
        get: function () {
            return new FilterableMenuItem(null /* name */, "Cancel" /* Cancel */, mailModuleOrchestrator.lazyCloseImmersiveReadingPane.importAndExecute, this.shouldShowBehaviorMap[28 /* SelectionNavigation */], 1 /* Right */);
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "newMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "groupId", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "categoryMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "replyMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "deleteMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "restoreMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "archiveDraftMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "junkMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "notJunkMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "translateMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "sweepMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "moveToMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "emptyFolderMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "markAllAsReadMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "markAsUnreadMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "markAsReadMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "scheduleMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "flagMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "unflagMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "pinMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "unpinMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "ignoreMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "stopIgnoringMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "overflowDivider", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "createRuleMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "printMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "showInImmersiveReaderMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "undoMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "optOutMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "selectPreviousMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "selectNextMenuItem", null);
    tslib_1.__decorate([
        computed
    ], MailCommandingBar.prototype, "closeImmersiveReadingPaneMenuItem", null);
    MailCommandingBar = tslib_1.__decorate([
        observer
    ], MailCommandingBar);
    return MailCommandingBar;
}(React.Component));
export default MailCommandingBar;
//# sourceMappingURL=MailCommandingBar.js.map